<template>
  <section class="land-info">
    <div class="right">
      <!-- <basic></basic>
      <transfer></transfer>
      <transaction></transaction> -->
      <div class="content">
        <div class="content-box">
          <div v-if="resData">
            <section class="basic">
              <div class="info overflow1 landnumber">
                {{ resData.landnumber }}
              </div>
              <div class="info overflow1 annoid">{{ resData.annoid }}</div>
              <div class="info overflow1 address">{{ resData.address }}</div>
              <div class="info overflow1 province">
                {{ resData.province ? resData.province : "四川省" }}
              </div>
              <div class="info overflow1 landcity">{{ resData.landcity }}</div>
              <div class="info overflow1 region">{{ resData.region }}</div>
              <div class="info overflow1 torus">{{ resData.torus }}</div>
              <div class="info overflow1 landarea1">
                {{
                  resData.landarea1 == "/"
                    ? resData.landarea1
                    : resData.landarea1 + "m²"
                }}
              </div>
              <div class="info overflow1 purpose">
                {{ resData.purpose }}
              </div>
              <div class="info overflow1 useryears">
                {{ resData.useryears }}
              </div>
              <!-- <div class="info overflow1 syzb">{{resData}}</div> -->
              <div class="info overflow1 ratio">
                {{ resData.ratio }}
              </div>
              <div class="info overflow1 volumeratio">
                {{ resData.volumeratio }}
              </div>
              <div class="info overflow1 buildarea">
                {{
                  resData.buildarea == "/"
                    ? resData.buildarea
                    : resData.buildarea + "m²"
                }}
              </div>
              <div class="info overflow1 businessarea">
                {{
                  resData.businessarea == "/"
                    ? resData.businessarea
                    : resData.businessarea + "m²"
                }}
              </div>
              <div class="info overflow1 greenrate">
                {{ resData.greenrate }}
              </div>
              <div class="info overflow1 buildingheight">
                {{ resData.buildingheight }}
              </div>
              <div class="info overflow1 sellremark">
                {{ resData.sellremark }}
              </div>
              <div class="info overflow1 rcscale">
                {{ resData.rcscale }}
              </div>
            </section>
            <section class="transfer">
              <div class="info overflow1 selltype">{{ resData.selltype }}</div>
              <div class="info overflow1 annotime">{{ resData.annotime }}</div>
              <div class="info overflow1 pmgz">竞地价、限价竞买、抽签竞得</div>
              <div class="info overflow1 pj">/</div>
              <div class="info overflow1 ysyq">
                自取得施工许可证之日起，9个月内申请办理预售许可证
              </div>
              <div class="info overflow1 zxyq">
                {{
                  resData.purpose.indexOf("住") >= 0
                    ? "成品住宅比例100%\n基础装修标准不高于3000"
                    : "/"
                }}
              </div>
              <div class="info overflow1 fixedprice">
                {{ resData.fixedprice }}
              </div>
              <div class="info overflow1 bond">
                {{ resData.bond == "/" ? resData.bond : resData.bond + "万元" }}
              </div>
              <div class="info overflow1 dj">/</div>
              <div class="info overflow1 startfloorprice">
                {{
                  resData.startfloorprice == "/"
                    ? resData.startfloorprice
                    : resData.startfloorprice + "元/㎡"
                }}
              </div>
              <div class="info overflow1 startprice">
                {{
                  resData.startprice == "/"
                    ? resData.startprice
                    : resData.startprice + "万元/亩"
                }}
              </div>
              <div class="info overflow1 starttotalprice">
                {{
                  resData.starttotalprice == "/"
                    ? resData.starttotalprice
                    : resData.starttotalprice + "万元"
                }}
              </div>
              <div class="info overflow1 totalprice">
                {{
                  resData.totalprice == "/"
                    ? resData.totalprice
                    : resData.totalprice + "万元"
                }}
              </div>
              <div class="info overflow1 otherinfo">
                {{ resData.otherinfo }}
              </div>
            </section>
            <section class="transaction">
              <div class="info overflow1 date">{{ resData.date }}</div>
              <div class="info overflow1 totalprice">
                {{
                  resData.totalprice == "/"
                    ? resData.totalprice
                    : resData.totalprice + "万元"
                }}
              </div>
              <div class="info overflow1 startfloorprice">
                {{
                  resData.startfloorprice == "/"
                    ? resData.startfloorprice
                    : resData.startfloorprice + "元/㎡"
                }}
              </div>
              <div class="info overflow1 tradeprice">
                {{
                  resData.tradeprice == "/"
                    ? resData.tradeprice
                    : resData.tradeprice + "万元/亩"
                }}
              </div>
              <div class="info overflow1 competecompany">
                {{ resData.competecompany }}
              </div>
              <img
                v-if="!showCpqy"
                class="look-img cpqy"
                src="./../../../assets/imgs/landInfo/cjjl.png"
                alt=""
                @click="showCpqy = !showCpqy"
              />
              <img
                v-else
                class="look-img cpqy"
                src="./../../../assets/imgs/landInfo/cpqy.png"
                alt=""
                @click="showCpqy = !showCpqy"
              />
              <img
                v-if="!showCjjl"
                class="look-img cjjl"
                src="./../../../assets/imgs/landInfo/cjjl.png"
                alt=""
                @click="showCjjl = !showCjjl"
              />
              <img
                v-else
                class="look-img cjjl"
                src="./../../../assets/imgs/landInfo/cpqy.png"
                alt=""
                @click="showCjjl = !showCjjl"
              />
            </section>
          </div>
        </div>
      </div>
      <div class="list-box">
        <div class="cpqy-box" v-show="showCpqy">
          <div class="close-box" @click="showCpqy = false"></div>
          <div class="table-box">
            <el-table
              :data="cpqyList"
              :header-cell-style="{
                background: '#246B95',
                color: '#f1f1f1',
              }"
              :max-height="400"
              height="400"
              style="width: 100%"
              ref="multipleTable"
            >
              <el-table-column
                prop="categoryStr1"
                label="竞价情况"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="number" label="企业" align="center">
              </el-table-column>
              <el-table-column prop="proportion" label="叫价" align="center">
              </el-table-column>
              <el-table-column
                prop="proportion"
                label="宣告次数"
                align="center"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="cjjl-box" v-show="showCjjl">
          <div class="close-box" @click="showCjjl = false"></div>
          <div class="table-box">
            <el-table
              :data="cpqyList"
              :header-cell-style="{
                background: '#246B95',
                color: '#f1f1f1',
              }"
              :max-height="400"
              height="400"
              style="width: 100%"
              ref="multipleTable"
            >
              <el-table-column prop="number" label="企业" align="center">
              </el-table-column>
              <el-table-column prop="proportion" label="号牌" align="center">
              </el-table-column>
              <el-table-column
                prop="proportion"
                label="最高出价"
                align="center"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import basic from "./basic.vue";
import transfer from "./transfer.vue";
import transaction from "./transaction.vue";
import * as http from "./api.js";
export default {
  data() {
    return {
      landName: "",
      resData: "",
      showCpqy: false,
      showCjjl: false,
      cpqyList: [],
      cjjlList: [],
    };
  },

  components: { basic, transfer, transaction },

  mounted() {
    this.landName = this.$route.query.name;
    // console.log("this.landName", this.landName);
    this.getData();
    let that = this;
    ue.interface.jrcGetLandName = function (val) {
      console.log("ue4 jrcGetLandName", val);
      that.landName = val[0];
      // console.log("this.landName", this.landName);
      that.getData();
    };
  },

  methods: {
    getData() {
      http.getLandInfoDetailByCode({ blockCode: this.landName }).then((res) => {
        // console.log("res", res);
        this.resData = res.data.data[0];
        this.bus.$emit("setLandInfo", this.resData);
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.land-info {
  position: fixed;
  top: 0;
  padding: 0 0px;
  width: 100%;
  height: 100vh;
  .right {
    position: absolute;
    right: 0;
    width: 800px;
    height: 1800px;
    background-image: url("./../../../assets/imgs/landInfo/bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;

    box-sizing: border-box;
    padding-top: 20px;
    .content {
      height: 1750px;
      overflow-y: scroll;
    }
    .content-box {
      width: 780px;
      height: 2434px;
      background-image: url("./../../../assets/imgs/landInfo/content_bg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin: 0 auto;
      position: relative;
      .overflow1 {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: pre-wrap;
        word-break: break-all;
      }
      .info {
        color: #fff;
        font-size: 28px;
        position: absolute;
      }
      .basic {
        .landnumber {
          left: 198px;
          top: 74px;
        }
        .annoid {
          left: 190px;
          top: 142px;
        }
        .address {
          left: 207px;
          top: 211px;
          -webkit-line-clamp: 2;
        }
        .province {
          left: 135px;
          top: 321px;
        }
        .landcity {
          left: 535px;
          top: 321px;
        }
        .region {
          left: 141px;
          top: 392px;
        }
        .torus {
          left: 535px;
          top: 392px;
        }
        .landarea1 {
          left: 192px;
          top: 464px;
        }
        .purpose {
          left: 584px;
          top: 464px;
          width: 200px;
        }
        .ratio {
          left: 160px;
          top: 533px;
        }
        .useryears {
          left: 591px;
          top: 533px;
        }
        .volumeratio {
          left: 217px;
          top: 603px;
        }
        .buildarea {
          left: 243px;
          top: 673px;
        }
        .businessarea {
          left: 247px;
          top: 743px;
        }
        .greenrate {
          left: 167px;
          top: 812px;
        }
        .buildingheight {
          left: 211px;
          top: 881px;
          -webkit-line-clamp: 4;
          max-width: 532px;
        }
        .sellremark {
          left: 147px;
          top: 1047px;
          max-width: 632px;
        }
        .rcscale {
          left: 591px;
          top: 603px;
        }
      }
      .transfer {
        .selltype {
          left: 201px;
          top: 1201px;
        }
        .annotime {
          left: 600px;
          top: 1201px;
        }
        .pmgz {
          left: 201px;
          top: 1271px;
        }
        .pj {
          left: 341px;
          top: 1341px;
        }
        .ysyq {
          left: 211px;
          top: 1411px;
          -webkit-line-clamp: 2;
        }
        .zxyq {
          left: 211px;
          top: 1521px;
          -webkit-line-clamp: 2;
        }
        .fixedprice {
          left: 198px;
          top: 1632px;
        }
        .bond {
          left: 620px;
          top: 1635px;
        }
        .dj {
          left: 237px;
          top: 1703px;
        }
        .startfloorprice {
          left: 620px;
          top: 1703px;
        }
        .startprice {
          left: 204px;
          top: 1778px;
          max-width: 170px;
        }
        .starttotalprice {
          left: 580px;
          top: 1778px;
        }
        .totalprice {
          left: 200px;
          top: 1848px;
        }
        .otherinfo {
          left: 159px;
          top: 1918px;
          -webkit-line-clamp: 4;
          width: 610px;
        }
      }
      .date {
        left: 199px;
        top: 2168px;
      }
      .totalprice {
        left: 578px;
        top: 2168px;
      }
      .startfloorprice {
        left: 220px;
        top: 2239px;
        max-width: 220px;
      }
      .tradeprice {
        left: 578px;
        top: 2239px;
      }
      .competecompany {
        left: 166px;
        top: 2309px;
      }
      .look-img {
        width: 156px;
        height: 40px;
        cursor: pointer;
        position: absolute;
      }
      .cpqy {
        left: 200px;
        top: 2384px;
      }
      .cjjl {
        left: 590px;
        top: 2384px;
      }
    }
  }
  .cpqy-box {
    width: 595px;
    height: 469px;
    background-image: url("./../../../assets/imgs/landInfo/cpqy_list.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding-top: 60px;
    box-sizing: border-box;
    position: relative;
  }
  .cjjl-box {
    width: 595px;
    height: 469px;
    background-image: url("./../../../assets/imgs/landInfo/cjjl_list.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-top: 20px;
    padding-top: 60px;
    box-sizing: border-box;
    position: relative;
  }
  .list-box {
    position: absolute;
    left: -680px;
    bottom: 0;
  }
  .close-box {
    position: absolute;
    width: 80px;
    height: 40px;
    right: 15px;
    top: 10px;
    cursor: pointer;
  }
  ::v-deep .el-table {
    color: #f1f1f1;
    background-color: transparent;
    .el-table__body-wrapper {
      background-color: transparent;
      // padding: 0 5px;
    }
    .el-table__body {
      width: 100% !important;
    }
    .el-table__header-wrapper {
      background: #246b95;
      .el-checkbox {
        display: none;
      }
    }
    th.el-table__cell > .cell {
      font-size: 25px;
      //padding: 0 0 0.3rem 0;
      // line-height: 1.2rem;
    }
    th.el-table__cell.is-leaf {
      border-bottom: none;
    }
    td.el-table__cell div {
      font-size: 30px;
      padding: 0 15px;
    }
    .el-table__cell {
      padding: 0rem 0;
    }
    td.el-table__cell,
    .el-table th.el-table__cell.is-leaf {
      border-bottom: none;
    }
    .el-table__row:nth-child(odd) {
      background: transparent;
    }
    .el-table__row:nth-child(even) {
      // &:nth-child(2n) {
      //   background-color: 4b4b4bb;
      // }
      background: rgba(120, 119, 119, 0.42);
    }
    .sort-caret {
      border-width: 11px;
    }
    .caret-wrapper {
      height: 60px;
    }
  }
  ::v-deep .el-table--border,
  .el-table--group {
    border: none;
  }
  ::v-deep .el-table--border .el-table__cell,
  .el-table__body-wrapper
    .el-table--border.is-scrolling-left
    ~ .el-table__fixed {
    border-color: #f4f6f81a;
  }
  ::v-deep
    .el-table--enable-row-hover
    .el-table__body
    tr:hover
    > td.el-table__cell {
    background: none;
  }
  ::v-deep .el-table .cell {
    line-height: 1.8;
    padding: 0;
    max-width: 400px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
  ::v-deep.el-table ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 15px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 20px;
  }
  ::v-deep.el-table ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px #409eff;
    background-color: #409eff;
  }
  ::v-deep.el-table ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px #a1a1a1;
    border-radius: 0;
  }
  ::v-deep .content::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 12px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 20px;
  }
  ::v-deep .content::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px #409eff;
    background-color: #409eff;
  }
  ::v-deep .content::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px #a1a1a1;
    border-radius: 0;
  }
}
</style>